import { useCallback, useState } from "react";
import { FaEnvelope } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../../services/api";
import Loading from "../../core/common/Loading";
import sulogLogo from '../../assets/images/logoMobile.svg';
import sulogLogin from '../../assets/images/sulog_login.svg';
import '../Login/Login.css';

const EsqueciSenha = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await api.post('/autenticar/tokenRedefinicaoSenha', { email });
      
      if (response.status === 200) {
        toast.success("Código enviado com sucesso!");
        // Navega para a tela de redefinição de senha / validação de código
        navigate('/redefinicaoSenha', { state: { email } });
      }
    } catch (error: any) {
      console.error(error);
      const errorMessage = error.response?.data?.message || "Erro ao tentar enviar o e-mail de redefinição.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [email, navigate]);

  return (
    <div className="login-container">
      {loading && <Loading loading={loading} />}
      <div className="login-left">
        <div className="logo-container">
          <img src={sulogLogin} alt="SULOG Logo" className="logo" />
          <h1>SULOG</h1>
          <p>Pátio de Triagem</p>
        </div>
      </div>
      <div className="login-right">
        <img src={sulogLogo} alt="SULOG Logo" className="logoMobile" />
        <div className="welcome-text">
          <h2 className="ola">Esqueci a Senha</h2>
          <p className="bem-vindo">Informe seu e-mail para receber o código</p>
        </div>
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <div className="input-icon">
              <FaEnvelope className="icon" />
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value.toLowerCase())} 
                required 
              />
            </div>
          </div>
          
          <div className="form-group form-inline" style={{ marginTop: '20px', gap: '15px' }}>
            <button 
              type="button" 
              className="login-button" 
              style={{ backgroundColor: '#F5B000', color: '#003366', fontWeight: 'bold' }} 
              onClick={() => navigate(-1)}
            >
              Voltar
            </button>
            <button type="submit" className="login-button">Enviar</button>
          </div>
        </form>
        
        <footer>
          <a href="/terms" className="terms-link">Termos de uso e política de privacidade</a>
          <p>Versão 2.0</p>
        </footer>
      </div>
    </div>
  );
};

export default EsqueciSenha;
